import { render, staticRenderFns } from "./AffiliatePaymentInfo.vue?vue&type=template&id=a183d13a&"
import script from "./AffiliatePaymentInfo.vue?vue&type=script&lang=ts&"
export * from "./AffiliatePaymentInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports